<template>
  <div
    :class="[
      'coupon-item',
      openMember ? 'open' : '',
      couponInvalid ? 'coupon-invalid' : ''
    ]"
  >
    <div v-if="!openMember" class="num">{{ coupon.couponNum }}</div>
    <div class="coupon-top">
      <div v-if="openMember" class="coupon-name">
        <tag
          :primary-color="primaryColor"
          :tag-style="nameStyle"
          :font-size="10"
        >
          {{ couponShowName }}
        </tag>
      </div>
      <!-- <div v-if="openMember" class="coupon-name">
        {{ coupon.couponDisplayName }}
      </div> -->
      <div class="title">
        <span class="symbol">¥</span>
        <span class="value">{{ coupon.couponValue }}</span>
      </div>
      <div class="msg">{{ coupon.thresholdMsg }}</div>
    </div>
    <div v-if="!openMember" class="coupon-bottom">
      {{ couponShowName }}
    </div>
    <div
      v-if="openMember"
      :class="['coupon-bottom', 'coupon' + couponStatus]"
      @click="handleBtn"
    >
      {{ couponText }}
    </div>
  </div>
</template>
<script>
import Tag from '@/common/widgets/good_tag'

const couponStatusText = {
  0: '去使用',
  1: '已使用',
  2: '已失效'
}
export default {
  components: {
    Tag
  },
  props: {
    coupon: {
      type: Object,
      default: () => ({})
    },
    openMember: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    couponStatus() {
      return this.coupon.status
    },
    couponText() {
      return couponStatusText[this.couponStatus]
    },
    couponInvalid() {
      return this.couponStatus === 1 || this.couponStatus === 2
    },
    couponShowName() {
      return this.coupon.couponDisplayName.slice(0, 6)
    },
    nameStyle() {
      return {
        'min-width': '140px',
        'text-align': 'center',
        height: '32px'
      }
    },
    primaryColor() {
      return this.couponInvalid ? '#8c8c8c' : '#96371c'
    }
  },
  methods: {
    handleBtn() {
      if (!this.couponInvalid && this.coupon.jumpUrl) {
        this.$track(this.$trackMap.memberIndex.couponUse)
        this.$autoRedirect(this.coupon.jumpUrl)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.coupon-item {
  position: relative;

  width: 1.64rem;
  height: 1.76rem;
  margin-right: 0.2rem;

  background-color: #fffdfb;
  border-radius: 0.12rem;
  border: 1px solid #f1cab0;

  box-sizing: border-box;

  .num {
    position: absolute;
    top: 0;
    right: 0;

    padding: 0px 5px;

    background-color: #f5d1a8;
    border-radius: 0 0.12rem 0 0.12rem;

    @include text(0.24rem, #984d19);
  }
  .coupon-top {
    padding: 0.14rem 0;

    .title {
      height: 0.56rem;

      line-height: 0.56rem;
      text-align: center;

      @include text(0.28rem, #8a542f);
      .value {
        font-size: 0.4rem;
        font-weight: bold;
      }
    }
    .msg {
      height: 0.34rem;
      margin-top: 0.04rem;

      line-height: 0.34rem;
      @include flex-row-center;
      @include text(0.24rem, #8a542f);
    }
  }
  &.open {
    .coupon-top {
      padding-top: 0;
      padding-bottom: 0.02rem;
      .coupon-name {
        width: 70px;
        height: 0.32rem;
        margin: 0 auto;

        background-image: url('../../../images/member/coupon_use.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;

        font-size: 0.24rem;
        color: #a87c5e;
      }
      .msg {
        margin-top: 0;
      }
    }
  }
  &.coupon-invalid {
    border: 1px solid #d9d9d9;
    .coupon-top {
      .coupon-name {
        background-image: url('../../../images/member/coupon_invalid.png');
      }
      .title,
      .msg {
        color: #8c8c8c;
      }
    }
  }

  .coupon-bottom {
    height: 0.52rem;
    padding: 0.08rem 0;

    box-sizing: border-box;

    border-top: 0.02rem dashed #f1cab0;

    line-height: 0.52rem;
    @include flex-row-center;
    @include text(0.24rem, #a87c5e);
    &.coupon0 {
      color: #f03100;
    }
    &.coupon1,
    &.coupon2 {
      color: #d9d9d9;
    }
  }
}
</style>
